import { Alert, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Input, Link, TextField } from "@mui/material";
import { Backend } from "../services/Backend";
import { useState } from "react";
import Cookies from "universal-cookie";

export function LoginPage() {
    const [error, setError] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const onLogin = () => {
        if (!email) {
            setError("Email is required");
            return;
        }
        if (!password) {
            setError("Password is required");
            return;
        }

        const body =  { email, password };

        Backend.post("auth/login", body)
            .then(res => {
                const cookies = new Cookies(null, { path: '/' });
                cookies.set('jwt', res.token);
                
                window.location.href = '/';
            })
            .catch(err => {
                setError(err);
            });
    }

    return <>
        <div className="w-[400px] mx-[auto] mt-[150px]">
            <h1 className="text-4xl text-center mb-[50px]">Login</h1>
            {error && <Alert severity="error">{error}</Alert> }
            <Box component="form" sx={{ mt: 1 }}>
                <TextField margin="normal" required fullWidth label="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} /> 
                
                <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={onLogin}
                >
                Sign In
                </Button>
                <div className="flex justify-between">
                    <Link href="/register" variant="body2">Don't have an account? Sign Up</Link>
                    <Link href="/forgot-password" variant="body2">Forgot password?</Link>
                </div>
            </Box>
        </div>
    </>
}